import type { ApiError } from '@chikara/types';

export function mapApiError(error: any): ApiError {
  if (error?.error) {
    const backendError = error.error;
    // Se deja omentado hasta que se arme el diccionario de errores
    // const validationMessages =
    //   backendError.details?.validation?.map(
    //     (v: any) => v.message
    //   ) ?? [];

    // const message = [
    //   backendError.message,
    //   ...validationMessages,
    // ].join('\n');

    return {
      type: 'http',
      status: error.response.status ?? 400,
      code: backendError.code,
      message: "Ocurrió un error al procesar tu solicitud. Por favor, intenta de nuevo.",
    };
  }
  if (error?.response === 'BAD' && error?.data?.exception) {
    const rawCode = String(error.data.exception.code || '');
    const rawDetail = String(error.data.exception.detail || '');

    let finalCode = rawCode;
    let finalMessage = rawDetail;

    const hasSpaces = (str: string) => str.includes(' ');
    const isCodeLike = (str: string) => str.length > 0 && !hasSpaces(str);

    // Swap if code contains spaces (like a sentence) and detail doesn't (like a slug/code),
    // or if detail is strictly numeric/dots (error code pattern)
    if (
      (hasSpaces(rawCode) && isCodeLike(rawDetail)) ||
      (/^[\d.]+$/.test(rawDetail) && !/^[\d.]+$/.test(rawCode))
    ) {
      finalCode = rawDetail;
      finalMessage = rawCode;
    }

    return {
      type: 'http',
      status: 400,
      code: finalCode,
      message: finalMessage,
    };
  }

  return {
    type: 'network',
    status: 500,
    message: 'Unexpected error',
  };
}
